/*
  Offers centralized management of alarm suppression form fields that can be used
  for both alerting 1.0 and 2.0 systems.

  Alerting 1.0 did not have restrictions on start time, the system could assume that the suppression would start 'now'
  However alerting 2.0 requires the start time to be at least 15 minutes past 'now'
  As a result, start time is given a cushion of 20 minutes which allows 5 minutes to complete the configuration without reporting errors from client/server-side validation

  Both the start and expiration times are transformed to cut off milliseconds and produce iso date strings

  These form fields are currently used in:
    - silent mode
    - edit test > alerting and notifications
    - agent details maintenance mode
*/

import moment from 'moment';

const fields = {
  startTime: {
    defaultValue: () => moment()
  },

  expirationTime: {
    label: 'Expires',
    defaultValue: () => moment().add(7, 'days')
  },

  neverExpire: {
    defaultValue: false
  }
};

export default fields;
